import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MainComponent } from './shared/pages/main/main.component';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './shared/guards/auth-guard';
import { AuthComponent } from './shared/pages/auth/auth.component';
import { ApiModule } from './modules/api';
import { ResetComponent } from './modules/authen/pages/reset/reset.component';
import { TranslateModule } from '@ngx-translate/core';
import { MomentModule } from 'ngx-moment';
import { ReactiveFormsModule } from '@angular/forms';
import { FactorComponent } from './modules/authen/pages/factor/factor.component';

const PUBLIC_ROUTES: Routes = [
  { path: '', loadChildren: './modules/authen/authen.module#AuthenModule' },
];

const SECURE_ROUTES: Routes = [
  { path: 'dashboard', loadChildren: './modules/home/home.module#HomeModule' },
  { path: 'cases', loadChildren: './modules/cases/cases.module#CasesModule' },
  { path: 'messages', loadChildren: './modules/messages/messages.module#MessagesModule' },
  { path: 'customers', loadChildren: './modules/customers/customers.module#CustomersModule' },
  { path: 'repairer', loadChildren: './modules/repairer/repairer.module#RepairerModule' },
  { path: 'reports', loadChildren: './modules/reports/reports.module#ReportsModule' },
  { path: 'settings', loadChildren: './modules/settings/settings.module#SettingsModule' },
  { path: 'myCases', loadChildren: './modules/myCases/cases.module#MyCasesModule' },
  { path: 'myBikes', loadChildren: './modules/myBikes/bikes.module#MyBikesModule' }
];

const routes: Routes = [
  { path: 'reset-password', component: ResetComponent },
  { path: 'two-factor-authentication', component: FactorComponent },
  { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
  { path: '', component: AuthComponent, data: { title: 'Public Views' }, children: PUBLIC_ROUTES },
  { path: '', canActivate: [AuthGuard], component: MainComponent, data: { title: 'Secure Views' }, children: SECURE_ROUTES },
  { path: '**', redirectTo: '/dashboard'},
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forRoot(routes),
    TranslateModule,
    MomentModule,
    ReactiveFormsModule,
    CommonModule,
  ],
  exports: [RouterModule],
  providers: [
    AuthGuard
  ],
  declarations: [MainComponent, AuthComponent, ResetComponent, FactorComponent]
})

export class AppRoutesModule { }
